//Questo serve per un problema con SockJs
if (typeof global === 'undefined') {
  window.global = globalThis;
}


import { createApp, h, markRaw } from 'vue'
import { createPinia } from 'pinia'
const pinia = createPinia();
import createDynamicRouter from './router';
import { useLoginStore } from "./stores/login.js";
import App from './App.vue';
import './style.css'
import PrimeVue from 'primevue/config';
import Ripple from 'primevue/ripple';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Breadcrumb from 'primevue/breadcrumb';
import InputText from 'primevue/inputtext';
import DataTable from 'primevue/datatable';
import TreeTable from 'primevue/treetable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';     //optional for column grouping
import Row from 'primevue/row';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Dropdown from 'primevue/dropdown';
import Button from 'primevue/button';
import Divider from 'primevue/divider';
import Password from 'primevue/password';
import Checkbox from 'primevue/checkbox';
import Card from 'primevue/card';
import Skeleton from 'primevue/skeleton';
import ProgressSpinner from 'primevue/progressspinner';
import ConfirmPopup from 'primevue/confirmpopup';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmationService from 'primevue/confirmationservice';
import Calendar from 'primevue/calendar';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Chip from 'primevue/chip';
import TriStateCheckbox from 'primevue/tristatecheckbox';
import Message from 'primevue/message';
import Fieldset from 'primevue/fieldset';
import Tooltip from 'primevue/tooltip';
import 'primevue/resources/primevue.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'prismjs/themes/prism-coy.css';
import 'leaflet/dist/leaflet.css';

import moment from 'moment'

import VueAxios from 'vue-axios'
import axios from 'axios'
import VueApexCharts from 'vue3-apexcharts'
import Dialog from 'primevue/dialog'
import { ref } from "vue";

import Error from './pages/Error.vue';
import Login from './pages/Login.vue';
import FirstAccess from './pages/FirstAccess.vue'
import NotFound from './pages/NotFound.vue';
import AnalyticsWebview from './pages/AnalyticsWebview.vue';
import AnalyticsGlobalWebview from './pages/AnalyticsGlobalWebview.vue';
import { createPersistedState } from 'pinia-persistedstate-plugin'
pinia.use(createPersistedState())

import config from "./config";
import functions from "./functions";

// import { i18n } from './i18n'
import { setupI18n } from './i18n'


async function bootstrap() {

	const app = createApp({
		computed: {
			ViewComponent() {
				if(this.$route.path.startsWith('/analytics-webview/')) {
					return { what: AnalyticsWebview };
				} else if(this.$route.path.startsWith('/analytics-global-webview')) {
					return { what: AnalyticsGlobalWebview };
				} else {
					switch (this.$route.path) {
						case '/login':
							return { what: Login, props: { tenant: "smegcons" } };
						case '/login-professional':
							return { what: Login, props: { tenant: "smeg" } };
						case '/first-access':
							return { what: FirstAccess };
						case '/error':
							return { what: Error };
						case '/access':
							return { what: Access };
						case '/notfound':
							return { what: NotFound };
						// case '/analytics-webview/':
						// 	return { what: AnalyticsWebview };
						default:
							return { what: App };
					}
				}
			},
		},
		render() { return h(this.ViewComponent.what, this.ViewComponent.props) }
	});
	app.config.globalProperties.$moment = moment
	app.config.globalProperties.$config = config;
	app.config.globalProperties.$functions = functions;
	app.config.globalProperties.$window = window;
	
	app.use(pinia);

	const i18n = await setupI18n()
	app.use(i18n)

	app.directive('tooltip', Tooltip);

	app.use(PrimeVue, { ripple: true });
	app.use(ToastService);
	app.use(VueApexCharts);
	app.use(VueAxios, axios);
	app.component('Message', Message);
	app.component('Breadcrumb', Breadcrumb);
	app.component('Toast', Toast);
	app.component('InputText', InputText);
	app.component('DataTable', DataTable);
	app.component('TreeTable', TreeTable);
	app.component('Column', Column);
	app.component('ColumnGroup', ColumnGroup);
	app.component('Row', Row);
	app.component('TabView', TabView);
	app.component('TabPanel', TabPanel);
	app.component('Dropdown', Dropdown);
	app.component('Button', Button);
	app.component('Divider', Divider);
	app.component('Password', Password);
	app.component('Checkbox', Checkbox);
	app.component('Card', Card);
	app.component('Skeleton', Skeleton);
	app.component('ProgressSpinner', ProgressSpinner);
	app.component('ConfirmPopup', ConfirmPopup);
	app.component('ConfirmDialog', ConfirmDialog);
	app.use(ConfirmationService);
	app.component('Calendar', Calendar);
	app.directive('ripple', Ripple);
	app.component('Accordion', Accordion);
	app.component('AccordionTab', AccordionTab);
	app.component('Chip', Chip);
	app.component('TriStateCheckbox', TriStateCheckbox);
	app.component('Dialog', Dialog);
	app.component('Fieldset', Fieldset);


	const login = useLoginStore();
	
	createDynamicRouter(login).then((router) => {
		pinia.use(({ store }) => {
			store.$router = markRaw(router)
		});
		router.beforeEach(function (to, from, next) {
			window.scrollTo(0, 0);
			next();
		});
		app.use(router);
		app.mount('#app');
	});

}

bootstrap()